import React, { ReactElement } from 'react';

import { MapRouteAnchor } from './MapRouteLink.styles';
import { ReactComponent as Marker } from './marker.svg';
import { Address } from 'types';
import { getGoogleMapsRoute } from './utilities';

type Props = {
  origin: Address;
  destination: Address;
};

export const MapRouteLink = ({ origin, destination }: Props): ReactElement => {
  return (
    <MapRouteAnchor
      href={getGoogleMapsRoute(origin, destination)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="View Route on Google Maps"
    >
      <Marker />
      View Route on Google Maps
    </MapRouteAnchor>
  );
};
